export default __webpack_public_path__ + "static/media/india1.6afbc443.jpg";